import styles from './CssUtils.css';
export function cssUtils() {
  for (var _len = arguments.length, options = new Array(_len), _key = 0; _key < _len; _key++) {
    options[_key] = arguments[_key];
  }

  return options.map(function (opt) {
    return styles[opt];
  }).filter(Boolean).join(' ');
}